export enum ReportType {
  EmployeeInformation = 'EmployeeInformation',
  ActiveEmployeeCount = 'ActiveEmployeeCount',
  SummaryOfRegulationDeviations = 'SummaryOfRegulationDeviations',
  InterruptedSynchronization = 'InterruptedSynchronization',
  LatestConnectionRun = 'LatestConnectionRun',
  CollectiveSalaryChange = 'CollectiveSalaryChange',
  ControlTool = 'ControlTool',
  SicknessLeave = 'SicknessLeave',
}

export interface Connection {
  connectionId: string;
  name: string;
  manual: boolean;
  regularPensionScheme: boolean;
  insurerName: string;
  product: string;
  contractNumber: string | null;
  schemeNumber: string | null;
  disabled: boolean;
}

export interface Employer {
  employerId: string;
  employerName: string;
  status: string;
  connections: Connection[];
}

export interface PaginatedResponse<T> {
  page: number;
  pageSize: number;
  totalItems: number;
  items: T[];
}

export interface EmployerFilter {
  employerId: string;
  connections: string[];
}

export interface ReportRequestPayload {
  reportType: string;
  selectAll: boolean;
  employersFilters: EmployerFilter[];
  endDateFilter?: string;
}

export type SelectionMode = 'multi' | 'single';

export interface ReportTypeConfig {
  selectionMode: SelectionMode;
  connectionFilter?: (connection: Connection) => boolean;
  allowSelectAll: boolean;
  hasEndDateFilter: boolean;
  showConnections: boolean;
}
